import { required } from 'ra-core';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { SimpleStack } from '../Moonstar/SimpleStack';
import { RolePermissionsEditor } from './RolePermissionsEditor';

export const RoleEdit = () => (
  <MoonstarEdit
    redirect="list"
    // System roles can't be deleted
    hideDelete={(record) => !!record.systemType}
  >
    <MoonstarEditForm className="max-w-none">
      <SimpleStack>
        <TextInput source="name" validate={required()} />
      </SimpleStack>
      <SimpleStack className="sm:w-full">
        <RolePermissionsEditor />
      </SimpleStack>
    </MoonstarEditForm>
  </MoonstarEdit>
);
